export default function isDarkColor(hexCode) {
  hexCode = hexCode.replace("#", "");

  const r = parseInt(hexCode.slice(0, 2), 16);
  const g = parseInt(hexCode.slice(2, 4), 16);
  const b = parseInt(hexCode.slice(4, 6), 16);

  const brightness = Math.sqrt(0.299 * (r * r) + 0.587 * (g * g) + 0.114 * (b * b));

  const threshold = 128;
  return brightness < threshold;
}
